import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BoxFile } from "../../types/BoxFile";
import api from "../../utils/api";

interface BoxFilesState {
  fetching: boolean;
  fetchError: string | null;
  caseFiles: BoxFile[];
}

const initialState: BoxFilesState = {
  fetching: false,
  fetchError: null,
  caseFiles: [],
};

export const fetchCaseFilesByCaseId = createAsyncThunk<
  BoxFile[],
  { case_id: string },
  { rejectValue: string }
>(
  "boxFiles/fetchCaseFilesByCaseId",
  async ({ case_id }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/api/case/${case_id}`
      );
      return response.data.data as BoxFile[];
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch case files"
      );
    }
  }
);

const boxFilesSlice = createSlice({
  name: "boxFiles",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCaseFilesByCaseId.pending, (state) => {
        state.fetching = true;
        state.fetchError = null;
        state.caseFiles = [];
      })
      .addCase(fetchCaseFilesByCaseId.fulfilled, (state, action) => {
        state.fetching = false;
        state.caseFiles = action.payload;
      })
      .addCase(fetchCaseFilesByCaseId.rejected, (state, action) => {
        state.fetching = false;
        state.fetchError = action.payload || "Failed to fetch case files";
      });
  },
});

export const {} = boxFilesSlice.actions;
export default boxFilesSlice.reducer;
